// extracted by mini-css-extract-plugin
export default {"icon":"CustomDealForm_icon__ly3XL"};